export default {
  EST_BLUE: 'blue',
  EST_GREEN: 'green',
  EST_PURPLE: 'purple',
  EST_RED: 'red',
  EST_YELLOW: 'yellow'
}
